import React from 'react'
import { Avatar, Modal } from 'antd'
import { RiDeleteBinLine } from 'react-icons/ri';

const BtnDeleteUC = (props) => {
    const { handleDelete, disabled } = props;
    const isCanDelete = disabled !== true;
    const handleClickDelete = () => {
        Modal.confirm({
            className: "modal-message modal-message-cancel",
            title: "",
            icon: <div className='anticon-delete'><RiDeleteBinLine className='icon-delete' /></div>,
            width: "600px",
            content: (
                <div style={{ width: "100%" }}>
                    <h3 className="mt-3">ยืนยันการลบข้อมูล</h3>
                </div >
            ),
            okText: "ยืนยัน",
            onOk () { handleDelete() },
            cancelText: "ยกเลิก",
            onCancel () { },
        })
    }
    return (
        <>
            {isCanDelete ?
                <Avatar shape="square" onClick={() => handleClickDelete()} icon={<RiDeleteBinLine className='icon-delete cursor-pointer' />} className="m-1" /> :
                <Avatar shape="square" icon={<RiDeleteBinLine className='icon-delete' disabled={true} />} className="m-1" />
            }
        </>
    )
}


export default BtnDeleteUC